// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewportParent {\n  background-color: blue;\n  z-index: 0;\n  flex-grow: 1;\n  overflow: hidden;\n}\n.viewportParent .viewport {\n  pointer-events: auto;\n}\n", ""]);
// Exports
module.exports = exports;
